/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import { getMenuTypography } from "utils/dropdownTypography";

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: ({ ownerState }) => ({
      minWidth: 160,
      marginTop: "var(--space-1, 4px)",
      border: "1px solid var(--border-default)",
      boxShadow: "var(--elevation-md)",
      padding: "var(--space-1, 4px)",
      fontSize: "var(--font-size-body-sm, 14px)",
      color: "var(--text-primary)",
      textAlign: "left",
      backgroundColor: "var(--surface-elevated) !important",
      borderRadius: "var(--radius-md, 10px)",
      ...getMenuTypography(ownerState),
    }),
    list: { padding: 0 },
  },
};

export default menu;
